import React from 'react';
import { Typography } from '@mui/material';

/**
 * @param {{ label?: string|null, sx?: object }} props
 */
export default function SponsorBenefitNote({ label, sx = {} }) {
  const text = String(label || '').trim();
  if (!text) return null;
  return (
    <Typography
      variant="body2"
      sx={{
        color: '#0288d1',
        fontWeight: 400,
        lineHeight: 1.45,
        ...sx,
      }}
    >
      {text}
    </Typography>
  );
}
